<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <!-- Search start -->
        <div class="card">
          <div class="card-body">

            <div class="row">
              <!-- <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4"></div> -->
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="search-box-container1">
                  <button class="search-icon" mat-icon-button (click)="searchByNumber(searchValue)">
                    <mat-icon>search</mat-icon>
                  </button>
                  <input type="text" [value]="searchValue ? searchValue: ''" (keydown)="searchByNumber(searchValue)"
                    placeholder="Customer details" [(ngModel)]="searchValue">
                </div>
              </div>
              <!-- <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4"></div> -->
            </div>

            <div class="row">


              <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <div class="search-box-container">
                  <button class="search-icon" mat-icon-button (click)="searchByWaybillNumber(searchNumberValue)">
                    <mat-icon>search</mat-icon>
                  </button>
                  <input type="number" [value]="way_bill_number ? way_bill_number: ''"
                    (keydown.enter)="searchByWaybillNumber(searchNumberValue)" placeholder="Way Bill Number"
                    [(ngModel)]="searchNumberValue">
                </div>
              </div>

              <!-- <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <div class="search-box-container">
                  <button class="search-icon" mat-icon-button (click)="searchByNumber(searchValue)">
                    <mat-icon>search</mat-icon>
                  </button>
                  <input type="text" [value]="searchValue ? searchValue: ''" (keydown)="searchByNumber(searchValue)"
                    placeholder="Customer details" [(ngModel)]="searchValue">
                </div>
              </div> -->


              <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <div class="search-box-container">
                  <button class="search-icon" mat-icon-button (click)="searchByMobNumber(searchMobNumberValue)">
                    <mat-icon>search</mat-icon>
                  </button>
                  <input type="number" [value]="mobile_number ? mobile_number: ''"
                    (keydown.enter)="searchByMobNumber(searchMobNumberValue)" placeholder="Mobile Number"
                    [(ngModel)]="searchMobNumberValue">
                </div>
              </div>

              <!-- <input type="text" [value]="searchValue ? searchValue: ''"
                    (keydown.enter)="searchByNumber(searchValue)"
                    placeholder="Way Bill Number/ Mobile Number/ Customer details" [(ngModel)]="searchValue"> -->

              <!-- <input type="text" [value]="searchValue ? searchValue: ''" (keydown)="searchByNumber(searchValue)"
                placeholder="Way Bill Number/ Mobile Number/ Customer details" [(ngModel)]="searchValue"> -->

              <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <button mat-icon-button style="color: #3fb543;" (click)="showControl()" *ngIf="show_full">
                  <span class="material-icons">
                    expand_less
                  </span> Short view
                </button>
                <button mat-icon-button style="color: #3fb543;" (click)="showControl()" *ngIf="!show_full">
                  <span class="material-icons">
                    expand_more
                  </span> Detailed view
                </button>
              </div>
              <!-- </div> -->

              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 table-responsive" *ngIf="datasource?.data.length > 0">
                <table mat-table [dataSource]="datasource" matSort
                  class=" success mat-elevation-z8 table table-bordered table-sm table-striped">
                  <ng-container matColumnDef="index" class="table">
                    <th style="background-color: lightseagreen; padding-right:15px" mat-header-cell *matHeaderCellDef
                      class="text-light text-center"> Sl </th>
                    <td mat-cell *matCellDef="let element;index as i"> {{i+1}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="waybill_date">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light text-center"> Date </th>
                    <td mat-cell *matCellDef="let element" class="nowrap">
                      {{element?.waybill_date | date:'dd-MM-yyyy'}}
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="waybill_no">
                    <th style="background-color: lightseagreen;" mat-header-cell *matHeaderCellDef mat-sort-header
                      class="text-light text-center nowrap pl-1"> Way Bill
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-left pl-1">
                      {{element?.receiver_code?element?.receiver_code+'/':'/'}} {{element?.waybill_no}}
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="sender_name">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light"> Sender </th>
                    <td mat-cell *matCellDef="let element" class="min pl-2" style="text-align:left">
                      {{element?.sender_name}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="receiver_name">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light"> Receiver </th>
                    <td mat-cell *matCellDef="let element" class="min pl-2" style="text-align:left">
                      {{element?.receiver_name}} - {{element?.receiver_mobile}}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="item_name">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light"> Commodity </th>
                    <td mat-cell *matCellDef="let element" class="pl-3" style="text-align:left">
                      {{element?.item_name}} </td>
                    <td style="text-align: center;" mat-footer-cell *matFooterCellDef><b> Total </b></td>
                  </ng-container>
                  <ng-container matColumnDef="loaded_pkg">
                    <th style="background-color: lightseagreen;" mat-header-cell *matHeaderCellDef mat-sort-header
                      class="text-light pl-1"> Loaded </th>
                    <td mat-cell *matCellDef="let element" class="text-right pr-2">
                      {{element?.loaded_pkg}} </td>
                    <td mat-footer-cell *matFooterCellDef class="text-right pr-2"><b>
                        {{loaded_total}}
                        <!-- {{getLoadedTotal1()}}  -->
                      </b></td>
                  </ng-container>
                  <ng-container matColumnDef="quantity">
                    <th style="background-color: lightseagreen;" mat-header-cell *matHeaderCellDef mat-sort-header
                      class="text-light pl-1"> PKG </th>
                    <td mat-cell *matCellDef="let element" class="text-right" style="padding-right: 10px;">
                      {{element?.quantity}} </td>
                    <td mat-footer-cell *matFooterCellDef class="text-right" style="padding-right: 10px;"><b>
                        {{quantity_total}}
                        <!-- {{getQuantityTotal1()}}  -->
                      </b></td>
                  </ng-container>
                  <ng-container matColumnDef="trip_name">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light nowrap"> Trip </th>
                    <td mat-cell *matCellDef="let element" class="nowrap pl-2" style="text-align:left">
                      {{element?.trip_name ? element.trip_name : '--'}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="check_point">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light nowrap"> Trip Position </th>
                    <td mat-cell *matCellDef="let element" class="pl-2" style="text-align:left">
                      {{element?.check_point ? element.check_point : '--'}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="tracking_position_status">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light"> Status </th>
                    <!-- <td mat-cell *matCellDef="let element" class="nowrap pl-3" style="text-align:left">
                      {{element?.tracking_position_status ? element.tracking_position_status : 'Packed'}} </td> -->
                    <td mat-cell *matCellDef="let element" class="pl-2" style="text-align:left">
                      {{element?.tracking_position_status ? element.tracking_position_status : '--'}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="narration">
                    <th style="background-color: lightseagreen; padding-left:15px" mat-header-cell *matHeaderCellDef
                      mat-sort-header class="text-light"> Narration </th>
                    <td mat-cell *matCellDef="let element" class="pl-2" style="text-align:left">
                      {{element?.narration ? element.narration : '--'}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <tr mat-header-row class="headColor" *matHeaderRowDef="displayedWayBills"></tr>
                  <tr mat-row class="bodyColor" *matRowDef="let row; columns: displayedWayBills;"></tr>
                  <tr mat-footer-row *matFooterRowDef="displayedWayBills"></tr>
                </table>
                <ng-container *ngIf="!datasource || datasource?.data.length == 0">
                  <h4 class="text-danger text-center">NO RECORDS AVAILABLE</h4>
                </ng-container>
              </div>
            </div>
          </div>
          <!-- Search end -->
        </div>

        <!-- Trip location track new design end -->

        <div class="row m-1">
          <div class="card pb-3" style="padding-right: 60px;">

            <div class="card-header">
              <h5 class="card-title text-center"
                style="background-color: #eeeeee; font-weight: 600; font-size: 15px; margin-bottom: 10px; text-decoration: underline;">
                <strong>{{ind_trip_details?.trip_name}}</strong>
                dated on {{ind_trip_details?.date | date:"dd-MM-yyyy"}}
              </h5>
            </div>

            <div class="card-body" style=" margin-bottom: 55px;">
              <span *ngFor="let trip_move of trip_movement ; index as i ; first as first ; last as last" class="mt-5">
                <span class="circle-desc"
                  style="font-size: 11px; margin-top: 13px; font-weight: 600; white-space: nowrap;">
                  {{trip_move?.check_point}}
                  <p style="font-weight: 600; text-align: start; font-size: 11px;">
                    {{trip_move?.tracking_position_status}}</p>
                  <!-- <span *ngIf="last">
                    <mat-icon style="margin-top: -6px;" class="text-primary">local_shipping
                    </mat-icon>
                  </span> -->
                  <span *ngIf="trip_move?.show_vehicle">
                    <mat-icon class="text-primary" style="margin-top: 15px;">local_shipping
                    </mat-icon>
                    <!-- <img src="../../assets/img/invoice-1.jpg" style="margin-top: 20px; width:50%; height:50%"> -->
                  </span>

                </span>
                <span class="circles"></span>
                <span class="bar" style="margin-top: 80px; margin-bottom: 5px;" *ngIf="(i != trip_movement.length-1)"
                  [ngStyle]="{'width': trip_move.width}"></span>
              </span>

            </div>
          </div>
        </div>

        <!-- Trip location track start -->
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
          <mat-tab-group mat-stretch-tabs dynamicHeight style="background-color: darkcyan;"
            class="example-stretched-tabs mat-elevation-z4">
            <mat-tab *ngFor="let trip of trip_history">
              <ng-template mat-tab-label>
                <a href="#{{trip?.trip_name}}" class="textdark" (click)="getTripDetails(trip?.id)"
                  data-toggle="collapse" role="button" aria-expanded="false">{{trip?.trip_name}}</a>
              </ng-template>

              <!-- <div class="row d-flex justify-content-center">
                <div class="col-12">
                  <div class="collapse show" id="{{ind_trip_details?.trip_name}}">
                    <div class="card card-bg" *ngIf="trip_movement!=undefined">
                      <div class="card-header box">
                        <h5 class="card-title text-center" style="background-color: #bbddd3;">
                          <strong>{{ind_trip_details?.trip_name}}</strong>
                          dated on {{ind_trip_details?.date | date:"dd-MM-yyyy"}}
                        </h5>
                      </div>
                      <div class="card-body">
                        <div class="container justify-content-center">
                          <ul>
                            <li style="color: darkcyan;"
                              *ngFor="let trip_move of trip_movement ; index as i ; first as first ; last as last"
                              [ngClass]="{ lastItem: last }">
                              <span></span>
                              <div>
                                <h5
                                  matTooltip="{{trip_move?.tracking_date | date:'dd-MM-yyyy'}} {{trip_move?.tracking_time}}"
                                  matTooltipClass="trip-movement-tooltip" aria-label="h5 that shows a red tooltip">
                                  <strong>{{trip_move?.check_point}}</strong>
                                  <small style="color: rgb(16, 17, 17);">
                                    {{trip_move?.tracking_date | date:"EEEE, MMM d, y"}}</small>
                                </h5>
                                <p><strong>{{trip_move?.tracking_position_status}}</strong></p>
                                <p><small>{{trip_move?.tracking_date | date:"EEEE, MMM d, y, h:mm:ss a"}}</small></p>
                              </div>

                              <div *ngIf="last">
                                <mat-icon style="color: #3fb543;">local_shipping
                                </mat-icon>
                              </div>
                              <div>
                                <mat-icon class="ml-2 mt-3" style="vertical-align: bottom; color: rgb(9, 124, 24);"
                                  *ngIf="!last || trip_move?.end_check_id != trip_move?.check_point_id">arrow_downward
                                </mat-icon>
                              </div>
                            </li>
                            <div *ngIf="!status">
                              **********************
                            </div>
                            <div *ngIf="!status">
                              **********************
                            </div>
                            <div *ngIf="!status">
                              <mat-icon class="ml-2 mt-3" style="vertical-align: bottom; color: rgb(189, 228, 15);"
                                *ngIf="!last || trip_move?.end_check_id != trip_move?.check_point_id">arrow_downward
                              </mat-icon>
                            </div>
                            <li style="color: rgb(184, 88, 25);" *ngIf="!status">
                              <div>
                                <h5 class="destination" *ngIf="!status">
                                  {{destination?.destination}}
                                </h5>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div> -->
            </mat-tab>
          </mat-tab-group>
        </div>

        <!-- Trip statistics graph start -->
        <div class="card">
          <!-- <div class="card-header">
          <div class="col-sm-12 col-md-11 col-lg-11 col-xl-11">
            <h3 class="card-title text-dark">Trip Statistics {{year_start | date}} - {{year_end | date}}
            </h3>
          </div>
          <div class="col-sm-12 col-md-11 col-lg-11 col-xl-11">
            <button mat-button class="float-right" color="primary" (click)="drawTripChart('line')">
              <mat-icon>get_app</mat-icon>Line
            </button>
          </div>

          <div class="col-sm-12 col-md-1 col-lg-1 col-xl-1 text-center">
            <button class="float-right" mat-icon-button color="primary" (click)="drawTripChart('bar')">
              <mat-icon>print</mat-icon>Bar
            </button>
          </div>
        </div> -->

          <div class="card-body">

            <div class="row justify-content-center">
              <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6">
                <h3 class="card-title text-center text-dark"><strong>Trip Statistics</strong> <small>
                    {{year_start | date}}
                    - {{year_end | date}}</small>
                </h3>
              </div>
              <div class="col-md-3 col-sm-6 col-lg-3 col-xl-3" *ngIf="years?.length>1">
                <mat-form-field appearance="outline">
                  <mat-label>Select Year</mat-label>
                  <mat-select placeholder="Select year" [(value)]="selected_year"
                    (selectionChange)="getTripStatistics()">
                    <mat-option *ngFor="let year of years" [value]="year.year">
                      {{year.year}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <!-- <button color="primary" mat-icon-button aria-label="Example icon-button with a refresh icon"
            (click)="drawTripChart('line')"> Line
          </button>
          <button color="primary" mat-icon-button aria-label="Example icon-button with a refresh icon"
            (click)="drawTripChart('bar')"> Bar
          </button> -->
            <!-- <button color="primary" mat-icon-button aria-label="Example icon-button with a refresh icon"
            (click)="drawTripChart('radar')"> Radar
          </button>
          <button color="primary" mat-icon-button aria-label="Example icon-button with a refresh icon"
            (click)="drawTripChart('pie')"> Pie -->
            <!-- <mat-icon>refresh</mat-icon> -->
            <!-- </button>
          <button color="primary" mat-icon-button aria-label="Example icon-button with a refresh icon"
            (click)="drawTripChart('scatter')"> Scatter Dataset -->
            <!-- <mat-icon>refresh</mat-icon> -->
            <!-- </button> -->

            <mat-button-toggle-group #group="matButtonToggleGroup">
              <mat-button-toggle value="line" aria-label="Line" (click)="drawTripChart(group.value)">
                <mat-icon>show_chart</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="bar" aria-label="Text align center" (click)="drawTripChart(group.value)">
                <mat-icon>bar_chart</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="pie" aria-label="Text align right" (click)="drawTripChart(group.value)">
                <mat-icon>pie_chart</mat-icon>
              </mat-button-toggle>
              <!-- <mat-button-toggle value="scatter" aria-label="Text align justify" (click)="drawTripChart(group.value)">
              <mat-icon>scatter_plot</mat-icon>
            </mat-button-toggle> -->
              <!-- <mat-button-toggle value="bubble" aria-label="Text align right" (click)="drawTripChart(group.value)">
              <mat-icon>bubble_chart</mat-icon>
            </mat-button-toggle> -->
              <!-- <mat-button-toggle value="radar" aria-label="Text align right" (click)="drawTripChart(group.value)">
              <mat-icon>bubble_chart</mat-icon>
            </mat-button-toggle> -->
            </mat-button-toggle-group>
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <canvas id="trip-statitis"></canvas>
              </div>
            </div>
          </div>
        </div>
        <!-- Trip statistics graph end -->
      </div>
    </div>
  </div>
</div>